module.exports = __webpack_public_path__ + "static/media/Business-Card-Design_RosnahHassan.5afc04f5.jpg";